module.exports = __webpack_public_path__ + "static/media/collage-photo-5.fb52413b.jpg";